import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { UpperCasePipe } from '@angular/common'

import { ProgressBarComponent } from '@shared/components/progress-bar/progress-bar.component'
import { ScoreComponent } from '@shared/components/score/score.component'
import { UserWithSummary } from '@core/interfaces/kpis.interface'
import { IconComponent } from '../icons/icons.component'

@Component({
  selector: 'kpis-summary-card',
  imports: [ProgressBarComponent, ScoreComponent, UpperCasePipe, IconComponent],
  templateUrl: './kpis-summary-card.component.html',
  styleUrls: ['./kpis-summary-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpisSummaryCardComponent {
  user = input.required<UserWithSummary>()
}
